import { render, staticRenderFns } from "./tongzhi.vue?vue&type=template&id=4a876344"
import script from "./tongzhi.vue?vue&type=script&lang=js"
export * from "./tongzhi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports